// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import { defaultColumns } from './ColumnSelectionContextSecondary'
import { FormatData } from '../../../pages/components/GeneralFunctions'
import config from '../../../config/config'

// Function that cleans the fetched data from the API based on the given structure data
export default function cleanFetchedData(fetchedData, structData) {
  
  const cleanedData = []
  for (var i = 0; i < fetchedData.length; ++i) {
    const dataPoint = fetchedData[i]
    // Update to use config primary key
    if (dataPoint[config.data.secondary_primary_key] && structData) {
      cleanedData.push(cleanFetchedDataPoint(dataPoint, structData))
    }
  }
  return cleanedData
}

// Function that cleans a single datapoint
function cleanFetchedDataPoint(fetchedDataPoint, structData) {
  const cleanedDataPoint = {}

  const defValue = 'NA'

  // Each of the variable fields retrieved from the backend are mapped to
  // their respective frontend fields and the data values are formatted accordingly
  for (let category in structData) {
    for (var i = 0; i < structData[category].length; ++i) {
      const backKey = structData[category][i]['data-key']
      const typeValue = structData[category][i]['data-format']
      cleanedDataPoint[backKey] = FormatData(
        fetchedDataPoint[backKey],
        defValue,
        typeValue
      )
    }
  }

  defaultColumns.forEach((key) => {
    if (cleanedDataPoint[key] === null || cleanedDataPoint[key] === undefined) {
      console.log(key)
      throw new Error('Invalid data, default column data not given')
    }
  })

  return cleanedDataPoint
}
